import api from "../api";

const API_BASE = "/api/Editor";
const API_TEMPLATES = "/api/Templates";

const listTemplates = async function (locale: string, idProduto?: number) {
  const url =
    idProduto && idProduto > 0 ? `${API_TEMPLATES}?idProduto=${idProduto}` : API_TEMPLATES;
  return await api.get(url, {
    headers: {
      "Accept-Language": locale,
    },
  });
};

const listTemplateEditor = async function (locale: string, id: number) {
  return await api.get(`${API_TEMPLATES}/${id}`, {
    headers: {
      "Accept-Language": locale,
    },
  });
};

const getProdutos = async function () {
  return api.get(`${API_BASE}/produtos`);
};

const listFormas = async function () {
  return api.get(`${API_BASE}/formas`);
};

const editorService = {
  listTemplates,
  getProdutos,
  listFormas,
  listTemplateEditor,
};

export default editorService;
